// @flow

export { externalSouthAfricanOutgoingPaymentMapper } from './outgoing-payment-mapper';
